import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { BatchHttpLink } from 'apollo-link-batch-http'
import { createAbsintheSocketLink } from '@absinthe/socket-apollo-link'
import { hasSubscription } from '@jumpn/utils-graphql'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { fetch } from 'redux-simple-auth'
import { onError } from 'apollo-link-error'
import absintheSocket from './absintheSocket'
import cacheRedirects from './cacheRedirects'
import store from './store'

const cache = new InMemoryCache({
  dataIdFromObject: ({ id }) => id,
  cacheRedirects
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    )
  }

  if (networkError) {
    console.log(`[Network error]: ${networkError}`)
  }
})

const parseBatchResult = new ApolloLink((operation, forward) =>
  forward(operation).map(({ payload, ...rest }) => ({
    ...payload,
    ...rest
  }))
)

const httpLink = ApolloLink.split(
  operation => hasSubscription(operation.query),
  createAbsintheSocketLink(absintheSocket),
  new BatchHttpLink({
    uri: `${process.env.REACT_APP_API_URL}/graphql`,
    fetch: (...args) => store.dispatch(fetch(...args))
  })
)

const client = new ApolloClient({
  cache,
  link: ApolloLink.from([errorLink, parseBatchResult, httpLink])
})

export default client



// WEBPACK FOOTER //
// ./src/config/apollo.js